export {
  RadioButton as WebRadioButton,
  Props as WebRadioButtonProps
} from './RadioButton';
export {
  RadioButtonLegacy as RadioButton,
  RadioButtonPropsLegacy as RadioButtonProps
} from './RadioButtonLegacy';
